import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import videojs from "video.js";
import qualityLable from "videojs-contrib-quality-levels";
videojs.registerPlugin("qualityLable", qualityLable);
import hlsQualitySelector from "videojs-hls-quality-selector";
videojs.registerPlugin("hlsQualitySelector", hlsQualitySelector);

import seekButon from "videojs-seek-buttons";
videojs.registerPlugin("seekButon", seekButon);
import playList from "videojs-playlist";
videojs.registerPlugin("playList", playList);


@Component({
  selector: "series-player",
  template: `
    <video
    id="my-video"
      #target
      class="video-js vjs-big-play-centered"
      controls
      aspectRatio="16:9"
      playsinline
      preload="none"
    >
   </video>
  `,
  styleUrls: ["./vjs-player.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class SeriesPlayerComponent implements OnInit, OnDestroy {
  userInfo: any = {};
  @ViewChild("target", { static: true }) target: ElementRef;
  @Input() options: {
    //playbackRates:any;
    aspectRatio: string;
    autoplay: boolean;
    sources: {
      src: string;
      type: string;
    }[];
    poster: string;
    videoDetail:any,
    redirectUrl: string,
  };

  player: videojs.Player;
  @Input() public set changeEpisode(value: number) {
    if(this.player){
      this.player.playlist.currentItem(value);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    }
  }
  // tslint:disable-next-line: variable-name
 constructor() {}
  ngOnInit(): void {
    // instantiate Video.js
    this.player = videojs(
      this.target.nativeElement,
      this.options,
      function onPlayerReady() {}
    );
    this.player.seekButtons({
      forward: 10,
      back: 10,
    });

    /**
     * HLS Quality selector
     */

    this.player.hlsQualitySelector({
      displayCurrentQuality: true,
      vjsIconClass: "vjs-icon-hd",
    });
    this.player.playList(this.options.sources)
    this.player.playlist.autoadvance(0);
    /* ADD PREVIOUS */
var Button = videojs.getComponent("Button");

// Extend default
var PrevButton = videojs.extend(Button, {
  //constructor: function(player, options) {
  constructor: function() {
    Button.apply(this, arguments);
    //this.addClass('vjs-chapters-button');
    
    /* FONT AWESOME ICON PREVIOUS NEXT */
    // this.addClass("icon-angle-left");
    // this.controlText("Previous");
    
    /* NEW VIDEOJS ICON PREV NEXT */
    this.addClass("vjs-icon-previous-item");
    this.controlText("Previous");
    
  },

  // constructor: function() {
  //   Button.apply(this, arguments);
  //   this.addClass('vjs-play-control vjs-control vjs-button vjs-paused');
  // },

  // createEl: function() {
  //   return Button.prototype.createEl('button', {
  //     //className: 'vjs-next-button vjs-control vjs-button',
  //     //innerHTML: 'Next >'
  //   });
  // },

  handleClick:()=> {
   
    this.player.playlist.previous();
  }
});

/* ADD BUTTON */
//var Button = videojs.getComponent('Button');

// Extend default
var NextButton = videojs.extend(Button, {
  //constructor: function(player, options) {
  constructor: function() {
    Button.apply(this, arguments);
    //this.addClass('vjs-chapters-button');

    /* FONT AWESOME ICON PREVIOUS NEXT */
    // this.addClass("icon-angle-right");
    // this.controlText("Next");
    
    /* NEW VIDEOJS ICON PREV NEXT */
    this.addClass("vjs-icon-next-item");
    this.controlText("Next");
  },

  handleClick:()=> {
    this.player.playlist.next();
  }
});

// Register the new component
videojs.registerComponent("NextButton", NextButton);
videojs.registerComponent("PrevButton", PrevButton);
//player.getChild('controlBar').addChild('SharingButton', {});
this.player.getChild("controlBar").addChild("PrevButton", {}, 0);
this.player.getChild("controlBar").addChild("NextButton", {}, 2);
    } 
    ngOnDestroy() {
      if (this.player) {
        this.player.dispose();
      }
    }
}
